import { ThemeOptions } from '@mui/material/styles/createTheme';

import { tokens } from '../../../theme/generated/tokens';

export const paperTheme: ThemeOptions['components'] = {
  DsPaper: {
    styleOverrides: {
      root: {
        backgroundColor: tokens.theme.bg.structural.surface,
        borderRadius: tokens.theme.radius.sm,
        boxShadow: `inset 0 0 0 1px ${tokens.theme.border.structural.neutral}`,
      },
    },
  },
};
